import React, { useState } from "react";
import { View, Text, StyleSheet, TextInput } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";

import Button from "@components/Button";
import t from "@constants/localization";
import { scale } from "@utils/scale";
import MessageWrapper from "./MessageWrapper";

const PATH = "screens/CLFlow/components/CustomTextInputBox";

const CustomTextInputBox = ({ item, onSubmit, onSkip, value }) => {
  const [text, setText] = useState(value);
  const isEnabled = text?.trim().length > 0;
  return (
    <MessageWrapper>
      <View style={styles.container}>
        <Text style={styles.questionText}>{item?.heading}</Text>
        <View>
          <TextInput
            multiline={true}
            numberOfLines={6}
            style={styles.textInput}
            onChangeText={setText}
            value={text}
            placeholder={t(`${PATH}/typeHere`)}
          />
          <View style={styles.buttonContainer}>
            {!item?.is_skipable && (
              <Button
                btnText={t(`${PATH}/continue`)}
                buttonFontType="bold"
                fontSize={scale(10)}
                RenderAs={TouchableOpacity}
                buttonWidth="100%"
                containerStyle={{ flex: 1, marginHorizontal: 2 }}
                onPress={onSkip}
                height={scale(50)}
                borderRadius={8}
                textStyle={{ fontSize: scale(16), lineHeight: 22 }}
                buttonColor="#ffffff"
                borderColor="#0000005C"
                textColor={!isEnabled ? "#000000" : "rgba(0,0,0,0.3)"}
                disabled={isEnabled}
              />
            )}
            <Button
              btnText={t(`${PATH}/submit`)}
              buttonFontType="bold"
              fontSize={scale(10)}
              RenderAs={TouchableOpacity}
              buttonWidth="100%"
              containerStyle={{ flex: 1, marginHorizontal: 2 }}
              onPress={() => onSubmit(item?.isLast, { [item.name]: text })}
              height={scale(50)}
              borderRadius={8}
              textStyle={{ fontSize: scale(16), lineHeight: 22 }}
              disabled={!isEnabled}
            />
          </View>
        </View>
      </View>
    </MessageWrapper>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#ffffff",
    borderRadius: 5,
    padding: 10,
    marginHorizontal: 10,
  },
  questionText: {
    fontSize: 16,
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontWeight: "600",
    marginVertical: 4,
  },
  textInput: {
    width: "100%",
    borderWidth: 1,
    padding: 10,
    textAlignVertical: "top",
    fontSize: 16,
    fontFamily: "NotoSansDevanagari-Regular",
    borderRadius: 8,
    borderColor: "#e6e6e6",
    marginVertical: 5,
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 8,
  },
  errorView: {
    marginHorizontal: 10,
    flexDirection: "row",
  },
  errorText: {
    color: "red",
    marginHorizontal: 5,
  },
});

export default CustomTextInputBox;
